import I18n from "@/localization/i18n";

export default {
  install(Vue) {
    Vue.mixin({
      methods: {
        $localize(ressource) {
          return I18n.t(ressource).toString();
        }
      }
    })
  }
};
